import { createSelector } from "@reduxjs/toolkit";
import {
  IIssueBoardApi,
  IMapOfEvaluationCategoriesApi,
  IMapOfRisikoProbabilitiesApi,
  IRisikoProbability,
} from "@mcapps/shared";
import { selectIssuesWithTypeISSUE } from "./issueSelectors";
import { buildRisikoCountMatrix } from "./issueUtils";
import { selectHttpIssueBoard } from "./redux/selectors/issueRtkSelectors";

export const selectBoardRisikoActiveProbabilities = createSelector(
  [selectHttpIssueBoard],
  (issueBoard: IIssueBoardApi): IMapOfRisikoProbabilitiesApi => {
    const record = Object.entries(issueBoard?.risikoSection?.probabilites || {}).reduce((acc, [key, probability]) => {
      if (probability.isActive) {
        acc[key] = probability;
      }
      return acc;
    }, {} as Record<string, IRisikoProbability>);
    return record;
  },
);

export const selectBoardRisikoActiveEvaluationCategories = createSelector(
  [selectHttpIssueBoard],
  (issueBoard: IIssueBoardApi): IMapOfEvaluationCategoriesApi => {
    return Object.entries(issueBoard?.risikoSection?.evaluationCategoriesConfig || {}).reduce(
      (acc, [key, category]) => {
        if (category.isActive) {
          acc[key] = category;
        }
        return acc;
      },
      {} as IMapOfEvaluationCategoriesApi,
    );
  },
);

export const selectCategoryMatrices = createSelector(
  [selectIssuesWithTypeISSUE, selectBoardRisikoActiveEvaluationCategories, selectBoardRisikoActiveProbabilities],
  (issues, activeEvaluationCategoriesConfig, activeProbabilities) => {
    return buildRisikoCountMatrix(issues, activeEvaluationCategoriesConfig, activeProbabilities);
  },
);

export const selectCategoryMatricesAfterTiltak = createSelector(
  [selectIssuesWithTypeISSUE, selectBoardRisikoActiveEvaluationCategories, selectBoardRisikoActiveProbabilities],
  (issues, activeEvaluationCategoriesConfig, activeProbabilities) => {
    return buildRisikoCountMatrix(issues, activeEvaluationCategoriesConfig, activeProbabilities, true);
  },
);
